import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nonfield-errors"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Warning:"),
  /*#__PURE__*/_createTextVNode(" adding more than 3 questions will affect student survey burden and data quality. ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "button-block has-below-divider"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "button-block form-buttons" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["onClick"]

import { onMounted, reactive, ref } from "vue";
import axios from "axios";
import { uniqueId, uniq } from "lodash";
import {
  getCustomQuestions,
  createCustomQuestions,
} from "@/services/customQuestionsService";
import type {
  APICustomQuestion,
  APICustomQuestionPayload,
} from "@/services/customQuestionsService";
import CustomQuestionForm, {
  FormState,
  FormErrors,
} from "@/components/CustomQuestionForm.vue";

const MAX_QUESTIONS = 5;

interface QuestionFormState extends FormState {
  key: string;
}

interface APIOptionValidationErrors {
  value?: string[];
}

interface APIValidationErrors {
  question_type?: string[];
  question_text?: string[];
  response_options?:
    | APIOptionValidationErrors[]
    | {
        non_field_errors?: string[];
      };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomQuestions',
  props: {
    provisionalCohortId: {},
    prevUrl: {},
    nextUrl: {}
  },
  setup(__props: any) {

const props = __props;



const questions = reactive<QuestionFormState[]>([]);
const errors = ref<FormErrors[]>([]);

const removeQuestion = (index: number) => {
  questions.splice(index, 1);
};

const toFormState = (question: APICustomQuestion): QuestionFormState => {
  return {
    key: uniqueId(),
    id: question.id,
    question_text: question.question_text,
    question_type: question.question_type,
    response_options: question.response_options.map((option) => option.value),
  };
};

const toPayload = (formData: QuestionFormState): APICustomQuestionPayload => ({
  id: formData.id,
  question_type: formData.question_type,
  question_text: formData.question_text,
  response_options: formData.response_options.map((value) => ({ value })),
});

const toResponseOptionErrors = (errors: APIValidationErrors): string[] => {
  if (!errors.response_options) {
    return [];
  } else if (Array.isArray(errors.response_options)) {
    return uniq(
      errors.response_options
        .flatMap((option) => option?.value || [])
        .filter((value) => value)
    );
  } else {
    return errors.response_options.non_field_errors || [];
  }
};

const toFormErrors = (apiErrors: APIValidationErrors): FormErrors => ({
  ...apiErrors,
  response_options: toResponseOptionErrors(apiErrors),
});

const saveCustomQuestions = async () => {
  try {
    const data = questions.map(toPayload);
    await createCustomQuestions(props.provisionalCohortId, data);
    window.location.href = props.nextUrl;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response) {
      const validationErrors = err.response.data as APIValidationErrors[];
      errors.value = validationErrors.map(toFormErrors);
    } else {
      throw err;
    }
  }
};

const addQuestion = () => {
  questions.push({
    question_type: "single",
    question_text: "",
    response_options: [],
    key: uniqueId(),
  });
};

onMounted(async () => {
  const apiQuestions = await getCustomQuestions(props.provisionalCohortId);
  questions.push(...apiQuestions.map(toFormState));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions, (question, index) => {
      return (_openBlock(), _createBlock(CustomQuestionForm, {
        key: question.key,
        question: question,
        title: `Custom Question #${index + 1}`,
        errors: errors.value[index],
        modelValue: questions[index],
        "onUpdate:modelValue": ($event: any) => ((questions[index]) = $event),
        onDelete: ($event: any) => (removeQuestion(index))
      }, null, 8, ["question", "title", "errors", "modelValue", "onUpdate:modelValue", "onDelete"]))
    }), 128)),
    (questions.length > 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (questions.length < MAX_QUESTIONS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-burg",
            onClick: _withModifiers(addQuestion, ["prevent"])
          }, " Add Custom Question ", 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        class: "btn",
        href: _ctx.prevUrl
      }, " Back ", 8, _hoisted_7),
      _createElementVNode("button", {
        class: "btn btn-burg",
        onClick: _withModifiers(saveCustomQuestions, ["prevent"])
      }, " Next ", 8, _hoisted_8)
    ])
  ], 64))
}
}

})